import axios, { AxiosRequestConfig, Method, AxiosResponse } from 'axios';

export async function apiRequest<T>(
  method: Method,
  url: string,
  payload?: any,
  headers: Record<string, string> = {},
): Promise<AxiosResponse<T>> {
  const config: AxiosRequestConfig = {
    method,
    url,
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    ...(method === 'GET' ? { params: payload } : { data: payload }),
  };

  return axios.request<T>(config);
}
